import ApolloClient, {
  defaultDataIdFromObject,
  FetchResult,
  InMemoryCache,
  IntrospectionFragmentMatcher,
  Observable
} from 'apollo-boost'

import { env } from '@app/env'
import { refreshSession } from '@app/modules/Auth/refreshSession'
import { resolveAuthToken } from '@app/modules/Auth/resolveAuthToken'

import IntrospectionResult from '../../graphql/introspection-result.json'

export const uri = env.REACT_APP_GRAPHQL_PUBLIC_URL

export const createApolloClient = () => {
  return new ApolloClient({
    cache: new InMemoryCache({
      dataIdFromObject(responseObject: any) {
        if (responseObject.uuid) {
          return `${responseObject.__typename}.${responseObject.uuid}`
        }

        if (responseObject.uid) {
          if (responseObject.__typename !== 'ProfessionalAuditSection')
            return `${responseObject.__typename}.${responseObject.uid}`
        }

        return defaultDataIdFromObject(responseObject)
      },
      fragmentMatcher: new IntrospectionFragmentMatcher({
        introspectionQueryResultData: IntrospectionResult
      })
    }),
    uri: uri,
    request: async (operation) => {
      const token = await resolveAuthToken()

      if (token) {
        operation.setContext({
          headers: {
            authorization: `Bearer ${token}`
          }
        })
      }
    },
    onError: ({ networkError, operation, forward }) => {
      const statusCode = (networkError as { statusCode?: number } | null)?.statusCode

      if (statusCode !== 401 || operation.getContext().hasRetriedAfterRefresh) {
        return
      }

      return new Observable<FetchResult>((observer) => {
        refreshSession()
          .then((token) => {
            if (!token) {
              observer.error(networkError)
              return
            }

            operation.setContext({
              hasRetriedAfterRefresh: true,
              headers: {
                authorization: `Bearer ${token}`
              }
            })

            forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            })
          })
          .catch((err) => observer.error(err))
      })
    }
  })
}

export const apolloClient = createApolloClient()
